import { Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';

// remove lazy when gimmick feature adopted
const NewLearnMore = lazyWithRetry(() => import('./NewLearnMore').then(module => ({ default: module.LearnMore })));

interface LearnMoreProps {
  mini?: boolean;
  productType?: string;
  productSubType?: string;
}
export function LearnMore(props: LearnMoreProps) {
  return <Suspense>{<NewLearnMore {...props} />}</Suspense>;
}
